import { CustomerState } from "../customer.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";

export const submitAdvDataReducer = (
  state: CustomerState,
  action: PayloadAction<Record<string, string>>,
) => {
  state.advData = { ...state.advData, ...action.payload };
};
